import { Navigate } from 'react-router-dom';

import { InstitutionFuturesProgressStep } from '@/context/progress';
import { RouteConfigProvider } from '@/context/route-config';
import FuturesAppropriatenessTestForm from '@/features/futures/components/appropriateness-test-form';
import FuturesAppropriatenessTestLayout from '@/features/futures/layouts/appropriateness-test';
import { useProfileClientCategorisationTreatment } from '@/hooks/queries/use-profile-client-categorisation-treatment';
import { useProfileInstitutionDetailsMeta } from '@/hooks/queries/use-profile-institution-details';
import LoadingPage from '@/pages/loading';

const InstitutionOnboardingFuturesAppropriatenessTestPage = () => {
  const {
    isLoading: isLoadingInstitutionDetailsMeta,
    data: { isRegulated },
  } = useProfileInstitutionDetailsMeta();
  const { isLoading: isLoadingClientCategorisationTreatment, data: clientCategorisationTreatment } = useProfileClientCategorisationTreatment();
  const isLoading = isLoadingInstitutionDetailsMeta || isLoadingClientCategorisationTreatment;

  if (isLoading) return <LoadingPage />;

  if (isRegulated) {
    if (!clientCategorisationTreatment) return <Navigate to="/institution/onboarding/futures/client-categorisation/treatment" replace />;

    return <Navigate to="/institution/onboarding/futures/appropriateness-test/result" replace />;
  }

  return (
    <FuturesAppropriatenessTestLayout step={InstitutionFuturesProgressStep.APPROPRIATENESS_TEST}>
      <RouteConfigProvider
        config={{
          clientCategorisationTreatment: '/institution/onboarding/futures/client-categorisation/treatment',
          appropriatenessTestResult: '/institution/onboarding/futures/appropriateness-test/result',
        }}
      >
        <FuturesAppropriatenessTestForm />
      </RouteConfigProvider>
    </FuturesAppropriatenessTestLayout>
  );
};
InstitutionOnboardingFuturesAppropriatenessTestPage.displayName = 'InstitutionOnboardingFuturesAppropriatenessTestPage';

export default InstitutionOnboardingFuturesAppropriatenessTestPage;
